import { NoAccess } from '../auth/components/NoAccess';

export default function NoAccessScreen() {
    return <NoAccess />;
}
